var logs = [
    {
        _id: 0, type: 'adventure', date: '01/01/2023', code: 'DDAL04-02 The Beast', lvlgain: '1', goldgain: '80', dtgain: '10',
        magicitems: [{ name: 'Cloak of Displacement', desc: 'Nerf this.' }], notes: 'Le MJ était trop nul', consumables: [{ name: 'Potion of Healing', qty: 1, desc: 'ok' }],
        storyAwards: [{ title: 'Anime fan', notes: 'You have disadvantages on charisma check in front of girls' }], pcid: 1, dm: 'Naruga'
    },
    {
        _id: 1, type: 'dmreward', date: '31/12/2022', notes: 'Gain magic item', magicitems: [{ name: 'Staff of Defense', desc: 'bonus action.' }], pcid: 1
    },
    {
        _id: 2, type: 'dmreward', date: '29/12/2022', notes: 'lvl Up', lvlgain: '1', pcid: 1
    },
    {
        _id: 3, type: 'purchase', date: '27/12/2022', notes: 'Potion of healing x2', goldgain: '-100', pcid: 1
    },
    {
        _id: 4, type: 'trade', date: '25/12/2022', notes: 'Ring of protection', magicitems: [{ name: 'Goggle of Nights', desc: 'bonus action.' }], goldgain: '-100', dtgain: -15, pcid: 1
    },
    {
        _id: 5, type: 'dtspend', date: '25/12/2022', notes: 'Catching up', dtgain: '-10', lvlgain: '1', pcid: 1
    },
    {
        _id: 6, type: 'dmreward', date: '31/12/2022', notes: 'Gain magic item', magicitems: [{ name: 'Staff of Defense', desc: 'bonus action.' }], pcid: 1
    },
    {
        _id: 7, type: 'dmreward', date: '29/12/2022', notes: 'lvl Up', lvlgain: '1', pcid: 3
    },
    {
        _id: 8, type: 'purchase', date: '27/12/2022', notes: 'Potion of healing x2', goldgain: '-100', pcid: 0
    },
    {
        _id: 9, type: 'trade', date: '25/12/2022', notes: 'Ring of protection', magicitems: [{ name: 'Goggle of Nights', desc: 'bonus action.' }], goldgain: '-100', dtgain: -15, pcid: 4
    },
    {
        _id: 10, type: 'dtspend', date: '25/12/2022', notes: 'Catching up', dtgain: '-10', lvlgain: '1', pcid: 2
    }
]

export default logs